/**
 * Characters that may precede a `/` for it to open the skill picker.
 *
 * Mirrors mentions: a slash opens the picker at the start of a line or after whitespace or
 * a quote. That avoids URLs, dates, and paths while allowing a user to add a Skill anywhere
 * in a natural-language prompt.
 */
export const SKILL_TRIGGER_PREVIOUS_CHAR_PATTERN = /(^|[\s"'])$/;
